import CommunicationModel from './communicationmodel';
const DeptLocCommModel = Backbone.Model.extend({
  defaults: {
    "errorMessage": "",
    "departmentLocationCommunicationID": 0,
    "departmentLocationID": 0,
    "communicationID": 0,
    "displayOrder": 0,
    "isActive": false,
    "isDeptDisplay": false,
    "isLocationDisplay": false,
    "communication": {} // phillips.CommunicationModel()
  },
  initialize: function() {
    this.set({
      "communication": new CommunicationModel(this.get("communication"))
    });
  }
});

export default DeptLocCommModel;
